// for reference node_modules/@digital-hig/theme-data/lib/build/json/light/design-tokens.json
const styleConstants = {};
styleConstants.COLORS = {
  accent: {
    clay: '#B3B3B3',
    plant: '#2bc275',
    iris: '#5F60FF',
    gold: '#ffc21a',
  },
  detail: {
    'slate-dark': '#666666',
    'slate-light': '#cccccc',
    transparent: 'rgba(0, 0, 0, 0)',
  },
  primary: {
    white: '#ffffff',
    black: '#000000',
  },
  product: {
    blue: '#186bff',
    plum: '#a90c7c',
    red: '#e51050',
    copper: '#ff6b00',
    brass: '#dbae03',
    silver: '#a69e84',
    'light-green': '#88a943',
    'dark-green': '#038c4a',
    'light-blue': '#37a5cc',
  },
  tint: {
    'clay-550': '#f5f5f5',
    'clay-600': '#c34922',
    'plant-600': '#00a85d',
    'iris-150': '#e0e0ff',
    'iris-200': '#bdbdff',
    'iris-300': '#9b9cfd',
    'iris-400': '#8080ff',
    'iris-450': '#6c6dff',
    'iris-550': '#5c5df9',
    'iris-575': '#4444f8',
    'iris-600': '#2c2c8c',
    'slate-100': '#f9f9f9',
    'slate-150': '#f2f2f2',
    'slate-175': '#e5e5e5',
    'slate-200': '#dedede',
    'slate-400': '#bfbfbf',
    'slate-450': '#aaaaaa',
    'slate-500': '#808080',
    'slate-600': '#333333',
    'slate-650': '#262626',
    'slate-700': '#212121',
    'slate-800': '#161616',
  },
};
module.exports = styleConstants;
